import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import { NotificationProvider } from '../../context/notification/context'
import { RouteUnauthorized } from '../route/route-unauthroized'
import { OrganizationScheduled } from '../../layout/authorized/org/organization/page/organization-scheduled'
import { SCHEDULED_PATH } from '../../shared/organization-deletion/organization-deletion'

// The owner's restricted restore session (delete organization, spec §2.5,
// plan Task 27): the organization is scheduled for deletion and the token
// reaches only the restore page's routes. No navigation, header or
// sidebar -- they would only call routes the organization gate refuses --
// and every path goes to the restore page, except the sign-in pages
// (/auth/account is "Switch organization").
export const RestrictedShell = () =>
  <div className="h-100 overflow-auto">
    <NotificationProvider>
      <Switch>
        <Route path="/auth" component={RouteUnauthorized} />
        <Route exact path={SCHEDULED_PATH} component={OrganizationScheduled} />
        <Redirect to={SCHEDULED_PATH} />
      </Switch>
    </NotificationProvider>
  </div>
